<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="items"
            sort-by="nome"
            ref="Table"
        >

            <template v-slot:cell(nome)="{ item }">
                {{ item.nome }}

                <template v-if="item.nomeSocial">
                    <template v-if="item.preferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL">
                        <strong>({{ item.nomeSocial }})</strong>
                    </template>

                    <template v-else>
                        ({{ item.nomeSocial }})
                    </template>
                </template>
            </template>


            <template v-slot:cell(dataExportacao)="{ item }">

                <span v-if="item.dataExportacao">
                    {{ item.dataExportacao }} às {{ item.horarioExportacao }} - {{ item.profissionalExportacao }}
                </span>
                <span v-else>-</span>
            </template>

            <template v-slot:cell(actions)="row">
                <rkm-button
                    @click="$router.push({
                        name: 'atencao-basica-ficha-complementar-edit',
                        params: {
                            id: row.item.id
                        }
                    })"
                    color="primary"
                    title="Editar"
                    small
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    @click.stop="handleDestroy(row.item.id)"
                    color="danger"
                    title="Excluir"
                    small
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>
    </div>
</template>

<script>

// Vuex
import { mapActions } from 'vuex';

// Mixins
import { repository, formats, stringCase, object, error } from '@/mixins';

// Enums.
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome';

export default ({
    data: () => ({
        items: [],
        fields: [
            {
                key: 'nome',
                label: 'Nome (Nome social)',
                sortable: true,
            },
            {
                key: 'dataAtendimento',
                label: 'Data',
                sortable: true,
                searchable: true,
            },
            {
                key: 'turno',
                label: 'Turno',
                sortable: true,
                searchable: true,
            },
            {
                key: 'profissional',
                label: 'Profissional',
                sortable: true,
                searchable: true,
            },
            {
                key: 'dataExportacao',
                label: 'Exportação',
            },
            {
                name: 'actions',
                key: 'actions',
                label: 'Ações',
                class: 'col-min'
            },
        ],
        enums: {
            preferenciaNome,
        }
    }),
    props: {
        id: {type: Number, default: null }
    },
    created() {

        this.repositories = {
            fichaComplementar: this.getConectaSusRepository('atencaoBasica.fichaComplementar')
        }

        this.load()
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.fichaComplementar.historico(this.id)
                .then(({ data }) => {

                    this.items = data.form.map(item => Object.assign({}, item))
                    this.$emit('paciente', data.paciente)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleDestroy(id) {
            const destroy = () => this.repositories.fichaComplementar.destroy(id)
                .then(() => this.items.splice(this.items.findIndex(i => i.id === id), 1))

            this.showDeleteConfirmation('Deseja realmente excluir a ficha complementar ?', destroy, this.handleError)
        }
    },
    mixins: [repository, formats, stringCase, object, error],
});
</script>